import attendanceOptions from "./attendanceOptions";
import cardHolderPresOptions from "./cardHolderPresOptions";
import cardPresenceOptions from "./cardPresenceOptions";
import cardRetOptions from "./cardRetOptions";
import conditionOptions from "./conditionOptions";
import inputCapOptions from "./inputCapOptions";
import operatorOptions from "./operatorOptions";
import panEntryOptions from "./panEntryOptions";
import pinEntryOptions from "./pinEntryOptions";
import presentmentOptions from "./presentmentOptions";
import securityConditionOptions from "./securityConditionOptions";
import terminalLocOptions from "./terminalLocOptions";
import terminalOpOptions from "./terminalOpOptions";
import terminalTypeOptions from "./terminalTypeOptions";

const advOptions = {
  attendanceOptions,
  cardHolderPresOptions,
  cardPresenceOptions,
  cardRetOptions,
  conditionOptions,
  inputCapOptions,
  operatorOptions,
  panEntryOptions,
  pinEntryOptions,
  presentmentOptions,
  securityConditionOptions,
  terminalOpOptions,
  terminalLocOptions,
  terminalTypeOptions
};

export default advOptions;